/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface PresignedUrl
 */
export interface PresignedUrl {
  /**
   *
   * @type {string}
   * @memberof PresignedUrl
   */
  url: string;
}

/**
 * Check if a given object implements the PresignedUrl interface.
 */
export function instanceOfPresignedUrl(value: object): value is PresignedUrl {
  if (!('url' in value) || value['url'] === undefined) return false;
  return true;
}

export function PresignedUrlFromJSON(json: any): PresignedUrl {
  return PresignedUrlFromJSONTyped(json, false);
}

export function PresignedUrlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PresignedUrl {
  if (json == null) {
    return json;
  }
  return {
    url: json['url'],
  };
}

export function PresignedUrlToJSON(value?: PresignedUrl | null): any {
  if (value == null) {
    return value;
  }
  return {
    url: value['url'],
  };
}
